"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _xstate = require("xstate");
var _availabilityMachine = _interopRequireDefault(require("../machines/availabilityMachine"));
function useAvailabilityTilesService(_ref) {
  let {
    customerCode,
    canBookOnline,
    locations,
    provider
  } = _ref;
  const availabilityMachine = (0, _react.useRef)((0, _availabilityMachine.default)({
    customerCode,
    canBookOnline,
    locations,
    provider
  }));
  const [state, setState] = (0, _react.useState)({
    current: availabilityMachine.current.initialState
  });
  const availabilityService = (0, _react.useRef)((0, _xstate.interpret)(availabilityMachine.current).onTransition(current => setState({
    current
  })));
  (0, _react.useEffect)(() => {
    const {
      current
    } = availabilityService;
    if (current) {
      current.start();
    }
    return () => current.stop();
  }, [availabilityService]);
  const {
    current: currentState
  } = state;
  const {
    availByLocId
  } = currentState.context;
  const {
    send
  } = availabilityService.current;
  return {
    currentState,
    send,
    availByLocId
  };
}
var _default = exports.default = useAvailabilityTilesService;